import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Item } from '@/types/item';
import { Modal } from '@/types/modal';
import { Textarea } from '@/components/molecules/common/Form';
import Container from '@/components/molecules/section/Container';
import { GridAction } from '@/components/molecules/section/Grid';
import ModalView from '@/components/modals/Modal';

const View: React.FC<{ item: Item }> = ({ item }) => {
  const { t } = useTranslation();
  const [modal, setModal] = useState<Modal | null>(null);

  const actions: GridAction[] = [
    {
      kind: 'Button',
      label: t('common.update').toUpperCase(),
      onClick: () => setModal({ kind: 'UpdateItemComment', item, onClose: () => setModal(null) }),
    },
  ];

  return (
    <>
      <Container
        title={t('item.internal_comment.title')}
        actions={actions}
        testId="internal_comment"
      >
        {item.internalComments ? (
          <Textarea
            rows={7}
            value={item.internalComments}
            disabled={true}
          />
        ) : (
          <Textarea
            rows={1}
            value={'-'}
            disabled={true}
          />
        )}
      </Container>
      <ModalView modal={modal} />
    </>
  );
};

export default View;
